import { GLTFLoader } from "ogl"

const loadGLTF = async (glContext, url) => {
  const gltf = await GLTFLoader.load(glContext, url)
  return gltf.scenes[0][0]
}

export default loadGLTF
